import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {ListResponse} from './list-response';
import {ImageModel} from './image-model';

@Injectable({
  providedIn: 'root'
})
export class ImageService {

  constructor(private httpClient: HttpClient) { }

  public getIcons(organizationId: string): Observable<ListResponse<ImageModel>> {
    return this.httpClient.get<ListResponse<ImageModel>>(
      `api/organizations/${organizationId}/images/icons`);
  }
}
